<template>
  <q-select
    v-model="localValue"
    v-bind="column.component ? column.component.props : {}"
    :clearable="true"
    :align="column.align"
    :hide-underline="true"
    placeholder="All"
    @input="applyFilter"
    @clear="applyFilter"
  ></q-select>
</template>
<script>
export default {
  name: 'SelectFilter',
  data () {
    return {
      localValue: ''
    }
  },
  props: {
    column: {
      type: Object
    },
    resource: {
      type: String,
      default () {
        return this.$route.meta.resource
      }
    },
    value: {}
  },
  computed: {
    labelField () {
      return this.column.relation
        ? this.column.relation.label || 'name'
        : this.column.field
    }
  },
  methods: {
    applyFilter () {
      if (this.column.relation) {
        this.$emit('apply', {
          [this.labelField]: this.localValue
        })
      } else {
        this.$emit('apply', this.localValue)
      }
    },
    setValue (v) {
      if (typeof v === 'object' && !Array.isArray(v) && v) {
        if (this.labelField && this.column.relation && v[this.labelField]) {
          this.localValue = v[this.labelField]
        }
      } else {
        this.localValue = v
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        this.setValue(v)
      },
      immediate: true
    }
  }
}
</script>
